module.exports = __webpack_public_path__ + "static/lframe-calculator-c5feb5aadcb5391d4b5cf1256b7f20e3.png";